<template>
  <div class="binds-checkbox" :class="[$bindsActiveTheme, checkClasses]">
    <div class="binds-checkbox-container" @click.stop="toggleCheck">
      <binds-ripple binds-centered :binds-active.sync="rippleActive" :binds-disabled="disabled">
        <input :id="id" type="checkbox" v-bind="attrs" :indeterminate.prop="indeterminate">
      </binds-ripple>
    </div>

    <label :for="id" class="binds-checkbox-label" v-if="$slots.default" @click.prevent="toggleCheck">
      <slot />
    </label>
  </div>
</template>

<script>
import BindsComponent from '../../core/BindsComponent'
import BindsCheckboxMixin from './BindsCheckboxMixin'
import BindsUuid from '../../core/utils/BindsUuid'

export default new BindsComponent({
  name: 'BindsCheckbox',
  mixins: [BindsCheckboxMixin],
  props: {
    id: {
      type: String,
      default: () => 'binds-checkbox-' + BindsUuid()
    }
  }
})
</script>

<style lang="scss">
  @import "../BindsAnimation/variables";

  $binds-checkbox-size: 20px;
  $binds-checkbox-touch-size: 48px;

  .binds-checkbox {
    width: auto;
    margin: 16px 16px 16px 0;
    display: inline-flex;
    position: relative;

    &:not(.binds-disabled) {
      cursor: pointer;

      .binds-checkbox-label {
        cursor: pointer;
      }
    }

    .binds-checkbox-container {
      width: $binds-checkbox-size;
      min-width: $binds-checkbox-size;
      height: $binds-checkbox-size;
      position: relative;
      border-radius: 2px;
      border: 2px solid transparent;
      transition: $binds-transition-stand;

      &:focus {
        outline: none;
      }

      &:before,
      &:after {
        position: absolute;
        transition: $binds-transition-drop;
        content: " ";
      }

      &:before {
        width: $binds-checkbox-touch-size;
        height: $binds-checkbox-touch-size;
        top: 50%;
        left: 50%;
        z-index: 11;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }

      &:after {
        width: 6px;
        height: 13px;
        top: 0;
        left: 5px;
        z-index: 12;
        border: 2px solid transparent;
        border-top: 0;
        border-left: 0;
        opacity: 0;
        transform: rotate(45deg) scale3D(.15, .15, 1);
      }

      .binds-ripple {
        width: $binds-checkbox-touch-size !important;
        height: $binds-checkbox-touch-size !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%);
        border-radius: 50%;
      }

      input {
        position: absolute;
        left: -999em;
      }
    }

    .binds-checkbox-label {
      height: $binds-checkbox-size;
      padding-left: 16px;
      position: relative;
      line-height: $binds-checkbox-size;
    }
  }

  .binds-checkbox.binds-indeterminate {
    .binds-checkbox-container {
      &:after {
        width: 12px;
        height: 2px;
        top: 50%;
        left: 50%;
        z-index: 7;
        border-style: solid;
        border-width: 0 0 2px;
        opacity: 0;
        transform: translate(-50%, -50%) !important;
      }
    }
  }

  .binds-checkbox.binds-checked {
    .binds-checkbox-container {
      &:after {
        opacity: 1;
        transform: rotate(45deg) scale3D(1, 1, 1);
        transition: $binds-transition-stand;
      }
    }
  }

  .binds-checkbox.binds-disabled.binds-checked {
    .binds-checkbox-container {
      border-color: transparent !important;
    }
  }

  .binds-checkbox.binds-required {
    label:after {
      position: absolute;
      top: 2px;
      right: 0;
      transform: translateX(calc(100% + 2px));
      content: "*";
      line-height: 1em;
      vertical-align: top;
    }
  }
</style>
